import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.COLORS.SUB_BACKGROUND};

   @media (max-width: 768px) {
         height: 100vh;
    }
`;
export const SubContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
   @media (max-width: 360px) {
         height: 100vh;
  justify-content: flex-start;
    }
    
`;
export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 30px;
  margin-left: 10px;
  text-align: center;

  @media (max-width: 360px) {
    font-size: 20px;
    }
     @media (max-width: 768px) {
        font-size: 20px;
    }
`;
export const Description = styled.h2`
  color: ${({ theme }) => theme.COLORS.DESCRIPTION};
  font-weight: 400;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
margin: 0;
    @media (max-width: 360px) {
    font-size: 13px;
    }
     @media (max-width: 768px) {
        font-size: 13px;
    }
`;
export const Content = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;
export const SubContent = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* padding: 20px; */
  padding-bottom: 50px;
`;
export const Image = styled.img`
  width: 50%;

  @media (max-width: 360px) {
      width: 80%;
    }
     @media (max-width: 768px) {
          width: 100%;
    }
`;

export const ImageButton = styled.img`
  width: 25%;

  @media (max-width: 360px) {
      width: 30%;
    }
     @media (max-width: 768px) {
          width: 60%;
    }
`;